import { render, staticRenderFns } from "./UserActionRevokeDialog.vue?vue&type=template&id=2ea40bef&"
import script from "./UserActionRevokeDialog.vue?vue&type=script&lang=js&"
export * from "./UserActionRevokeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports